<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Name" v-model="name" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <vs-input label="Code" v-model="code" class="mt-5 w-full" name="item-code" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-code')">{{ errors.first('item-code') }}</span>

        <!-- CATEGORY -->
        <div class="mt-5 w-full">
          <label class="vs-input--label">Property Type</label>
          <v-select v-model="property_type" class="w-full rounded-lg cursor-pointer" placeholder="Please select"
                    :clearable="false" name="item-type" v-validate="'required'" :options="property_type_options" @input="onPropertyTypeChange"/>
          <span class="text-danger text-sm" v-show="errors.has('item-type')">{{ errors.first('item-type') }}</span>
        </div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      id: null,
      name: '',
      code: '',
      property_type: '',
      property_type_options: [],
      property_types: [],
      user_group:1,
      is_readonly: 0,
      is_required: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { name, id, code, property_type, property_types, user_group } = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.code = code
        this.property_type = property_type
        this.property_types = property_types
        this.user_group = user_group
        this.initValues()
      }
      this.fixTypeOptions()
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.code && this.property_type
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    fixTypeOptions () {
      const list = []
      this.property_types.forEach(function (item) {
        const option_data = {
          value: item.code,
          code: item.code,
          label: item.name
        }
        list.push(option_data)
      })
      this.property_type_options = list
    },
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.code = ''
      this.property_types = this.$store.state.api.property_types
      this.property_type = this.property_types[0]
      this.user_group = this.data.user_group
      this.is_required = 0
      this.is_readonly = 0
    },
    onPropertyTypeChange () {
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        this.$vs.loading()
        if (result) {
          const obj = {
            propertyId: this.id,
            name: this.name,
            code: this.code,
            property_type: ((typeof this.property_type === 'string') ? this.property_type : this.property_type.value),
            user_group: this.user_group,
            is_readonly: this.is_readonly,
            is_required: this.is_required,
            active: 1
          }
          if (obj.property_type === 'list') {
            obj.fields = [{name: 'id'}]
          }

          this.$store.dispatch('api/addProperty', obj).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$emit('closeSidebar')
            this.initValues()
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err)
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$emit('closeSidebar')
            this.initValues()
          })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
